const faqs = [
  { q: '酷漫屋的漫画都是免费的吗？', a: '是的，酷漫屋所有漫画资源完全免费，无需注册即可畅享海量日漫、韩漫、国漫在线免费阅读，我们致力于为漫画爱好者提供零门槛的优质阅读体验。' },
  { q: '什么是下拉式滚动阅读？', a: '下拉式滚动阅读是一种连续翻页模式，您只需向下滑动屏幕即可无缝加载后续章节内容，无需点击翻页按钮，让追漫体验更加流畅自然，特别适合手机端沉浸式阅读。' },
  { q: '酷漫屋支持哪些漫画类型？', a: '酷漫屋覆盖热血、恋爱、奇幻、悬疑、搞笑、校园、冒险、科幻、古风、都市等几乎所有漫画题材，无论是日漫经典、韩漫热门还是国漫新番，这里应有尽有。' },
  { q: '漫画更新频率怎么样？', a: '酷漫屋每日稳定更新200+章节，热门连载漫画保持与官方同步的更新节奏，您可以第一时间追到最新话，再也不用担心错过精彩剧情。' },
  { q: '需要下载APP才能看漫画吗？', a: '不需要！酷漫屋支持网页端直接阅读，打开浏览器即可畅享免费漫画。当然我们也提供移动端专属优化，如果您更喜欢APP阅读体验，可以下载我们的客户端获得更便捷的服务。' },
  { q: '可以在酷漫屋找到冷门漫画吗？', a: '当然可以！酷漫屋不仅收录人气热门漫画，也重视小众精品和冷门佳作。我们的漫画库涵盖经典老番到最新连载，无论多冷门的作品都有机会在这里找到。' },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          关于酷漫屋免费漫画在线阅读，你想知道的都在这里
        </p>
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-background-50 rounded-xl border border-background-200/80 overflow-hidden">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">{faq.q}</h3>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full bg-primary-100 text-primary-500 group-open:rotate-45 transition-transform">
                  <i className="ri-add-line text-sm"></i>
                </div>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}